// extracted by mini-css-extract-plugin
export default {"columnInformation":"CsvColumnInformation_columnInformation__8rfuh","name":"CsvColumnInformation_name__kH6kn"};